import { selectComponentState } from 'projectRedux/store';
import { eppTypeAdapter } from '../adapters/eppTypeAdapter';

export const {
  selectAll: selectAllEppTypes,
  selectById: selectEppTypeById,
  selectEntities: selectEppTypeEntities,
} = eppTypeAdapter.getSelectors((state) => selectComponentState(state).eppTypes);
